// # Společná funkcionalita/dependencies pro použití map na webu
// # Tyto dependencies lze načíst pomocí lazy loadingu nebo pomocí skriptu při načtení stránky

export function performOpenStreetMapLoading() {
  let branchMap = document.getElementById("branchMap");

  if (!branchMap) {
    return;
  }

  let lon = branchMap.dataset.longitude;
  let lat = branchMap.dataset.latitude;
  let address = branchMap.dataset.address;
  let brdata = branchMap.dataset.branches;

  let map = L.map("branchMap").setView([lat, lon], 16);

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);

  if (brdata) {
    computeMap(brdata, map);
  } else {
    L.marker([lat, lon]).addTo(map).bindPopup(address).openPopup();
  }
}

function computeMap(brdata, map)
{
    // spocitame stred mapy a zoom
    let maxlat = Number.NEGATIVE_INFINITY;
    let maxlon = Number.NEGATIVE_INFINITY;
    let minlat = Number.POSITIVE_INFINITY;
    let minlon = Number.POSITIVE_INFINITY;

    const branches = JSON.parse(brdata);
    for (var i = 0; i < branches.length; i++){
        if (branches[i]['lat']>maxlat){
            maxlat = parseFloat(branches[i]['lat']);
        }
        if (branches[i]['lat']<minlat){
            minlat = parseFloat(branches[i]['lat']);
        }
        if (branches[i]['lon']>maxlon){
            maxlon = parseFloat(branches[i]['lon']);
        }
        if (branches[i]['lon']<minlon){
            minlon = parseFloat(branches[i]['lon']);
        }
        L.marker([branches[i]['lat'], branches[i]['lon']])
            .addTo(map)
            .bindPopup(branches[i]['adr']);
            //.openPopup();
    }

    let zoom = 8;
    // zoom se určí podle rozdílu lat
    const delta = maxlat - minlat;
    if (delta<0.4){
        zoom = 9;
    }
    if (delta<0.2){
        zoom = 10;
    }
    if (delta<0.1){
        zoom = 11;
    }
    if (delta<0.05){
        zoom = 12;
    }
    if (delta<0.02){
        zoom = 13;
    }
    if (delta<0.01){
        zoom = 14;
    }
    if (delta<0.005){
        zoom = 15;
    }

    map.setView([(minlat + maxlat)/2,(minlon + maxlon)/2],zoom);
}
